import { useMemo } from "react";
import { useLocalization } from "../../../hooks/useLocalization";
import { useScoreboardContext } from "../../../hooks/useScores";
import { ITeamScores } from "../../../types/types";

const sortRegularSeasonTeams = (teams: ITeamScores[]): ITeamScores[] =>
  [...teams].sort((a, b) => {
    const seriesWinDiff = b.wins - a.wins;
    if (seriesWinDiff !== 0) return seriesWinDiff;

    const gameWinDiff = b.gameWins - a.gameWins;
    if (gameWinDiff !== 0) return gameWinDiff;

    const seriesLossDiff = a.losses - b.losses;
    if (seriesLossDiff !== 0) return seriesLossDiff;

    const gameLossDiff = a.gameLosses - b.gameLosses;
    if (gameLossDiff !== 0) return gameLossDiff;

    return a.name.localeCompare(b.name);
  });

export const useRegularSeasonScoreboard = (teamsOverride?: ITeamScores[]) => {
  const { regularTeams } = useScoreboardContext();
  const { strings } = useLocalization();
  const regularTeamsList = teamsOverride ?? regularTeams;

  const sortedTeams = useMemo(() => sortRegularSeasonTeams(regularTeamsList), [regularTeamsList]);

  return {
    strings,
    sortedTeams,
  };
};
